import { QConfigGeneratorCreation } from '@exam-management/qconfig-generator-creation';

export default function QConfigGeneratorsCreationPage() {
  return <QConfigGeneratorCreation />;
}
